import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSoundFx: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconSoundFx"><Path d="M13 2.97046V21.0296L5.8043 17.0001H1V7.00005H5.8043L13 2.97046Z" fill="currentColor"/><Path d="M19.5 4.99976L20.5804 7.91939L23.5 8.99976L20.5804 10.0801L19.5 12.9998L18.4196 10.0801L15.5 8.99976L18.4196 7.91939L19.5 4.99976Z" fill="currentColor"/><Path d="M17.5 12.9998L18.3103 15.1895L20.5 15.9998L18.3103 16.81L17.5 18.9998L16.6897 16.81L14.5 15.9998L16.6897 15.1895L17.5 12.9998Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSoundFx;
